import { DividerProps } from '@lsy-netline/netline-ui/Divider';
import clsx from 'clsx';
import { forwardRef } from 'react';

import { Divider as MuiDivider, styled } from 'netline-ui';

import styles, { dividerClasses } from './Divider.styles';

const DividerRoot = styled(MuiDivider, { name: dividerClasses.$name })(styles);

const Divider = forwardRef<HTMLHRElement, DividerProps>(({ className, ...props }: DividerProps, ref) => {
  return <DividerRoot ref={ref} className={clsx(dividerClasses.root, className)} {...props} />;
});

export default Divider;
